import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Registration, UserRegistration } from '~auth/model';
import { RegistrationService } from '~auth/services/registration.service';

@Injectable()
export class AORegistrationService extends RegistrationService {
  registerUser(user: UserRegistration): Observable<any> {
    return this.http.post(`${this.AO_URL}/customers/registration`, user, { responseType: 'text' });
  }

  verifyUser(registration: Registration): Observable<any> {
    return this.http.put(`${this.AO_URL}/customers/validationcodes/${registration.registrationCode}`, registration.username,
      { withCredentials: true });
  }

  forgotPassword(username: string): Observable<any> {
    return this.http.get(`${this.AO_URL}/app/forgotpassword?email=${username}&url=uw.url`);
  }

  resetPassword(requestId: string, newPassword: string): Observable<any> {
    return this.http.put(`${this.AO_URL}/app/forgotpassword?requestId=${requestId}&newPassword=${newPassword}`, null,
      { responseType: 'json' });
  }

  resendValidationCode(email) {
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem(`${this.tokenName}`), 'Content-Type': 'application/json' })
    return this.http.post(`${this.AO_URL}/customers/validationcodes/`, email,
      { headers: headers, responseType: 'text', withCredentials: true });
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/auth/services/ao-registration.service.ts